import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Galary from './Galary';
import All from "./All";
import { SearchImages } from "../GoogleSearch";
import GoogleSearch from "./GoogleSearch";

const Main = ({chatOpen,setChatOpen,images}) => {

    return (
        <Router>
            <Routes>
                <Route path="/" element={<All chatOpen={chatOpen} setChatOpen={setChatOpen} />} />
                <Route path="/galary" element={<Galary chatOpen={chatOpen} setChatOpen={setChatOpen} images={images} />} />
                <Route path="/google-search" element={<GoogleSearch chatOpen={chatOpen} setChatOpen={setChatOpen} images={SearchImages} />} />
            </Routes>
        </Router>
    )
}

export default Main